export const paymentStatuses = {
  SUCCESS: 'success',
  ERROR: 'error',
  ABORT: 'abort',
  PENDING: 'pending',
  AUTHORISE_REQUESTED: 'authorisedRequested',
}
